import { cached, TTL } from '~/utils/ttlCache';

interface FetchClient {
  fetch: <T = any>(query: string, params?: Record<string, unknown>) => Promise<T>;
}

/**
 * Runs a Sanity query. On the server the result is cached in memory (see ttlCache),
 * in the browser the query goes straight to the API CDN.
 */
export const cachedSanityFetch = <T = any>(
  client: FetchClient,
  query: string,
  params?: Record<string, unknown>,
  ttlMs: number = TTL.short
): Promise<T> => {
  if (!process.server) {
    return client.fetch<T>(query, params);
  }

  const key = `q:${query}:${params ? JSON.stringify(params) : ''}`;
  return cached<T>(key, ttlMs, () => client.fetch<T>(query, params));
};
